<template>
<div class="content-wrappper ">
  <div class="regulation-main" :class="isFilterApplied?'table-height':'filter-height'">
    <div class="col-md-12 regulation-header regulationBackground">
        <div class="pb-22  pr-24 d-flex justify-content-between ">
          <span class="m-0 regulation_check">{{ $t('manage') }} {{$t('complianceLabel')}}</span>
          <button v-if="roleId===roleInfo['RA Admin'] && renderFilterData.length"
          class="btn download_button"
          @click="downloadRecords($event,renderFilterData,'all')"
          ><img src="/static/images/icons/Download.svg" class="download-btn-plus-icon pr-10" alt="plus-icon" />{{$t('download')}}
        </button>

        </div>
         <div class="col-xs-12 col-md-12 col-sm-12 tabs-main p-0 pr-24">
             <div class="col-xs-12 col-md-12 col-sm-12 main-tabs p-0">

                 <div class="pl-2" v-for="(filter, index) in headerTabOptions" :key="index">
                    <div :class="{ active_progress_bar: activeHeaderClass === filter }" @click="handleActiveTab(filter)" >
                    <div class="ul-new-font cursor-pointer pb-11"  :class="activeHeaderClass === filter?'active-text':'in-active-text'"> {{ translate(filter) }}</div>
                </div>
                </div>
        </div>
      </div>

    <div class="col-xs-12 p-0 ">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0 search-container-wraper search-outer">
            <div class="search-container reg-search col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 pr-24">
              <div style="position:relative">
                <search-box  v-model="searchValue" :searchCount="searchCount" @getList="filterManageComplianceList" componentName="manage compliance" :showFilter="true" :selectedColumns="columnOptions" @updateColumns="updateColumns" @updateFilterMode="updateFilterMode"></search-box>
              </div>
            </div>
        </div>
    </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 pl-24 pr-24 regulationBackground" :class="isFilterApplied?'':'main-table'" >
      <div class="regulations">
        <table class="table table-responsive registration-data" id="regulationDataList">

            <tr style="background-color: #E6E6E6; !important;">
                <th  v-if="manageComplianceColumns.indexOf('Issue Severity')>-1">
                <div class="tableHeader  cursor-pointer" :class="manageComplianceColumns.indexOf('Issue Severity')==0?'pl-12': ''" @click="arrowDirection.issueSeverity = -(arrowDirection.issueSeverity), sortBy('issueSeverity', arrowDirection.issueSeverity)">
                  <div class="ellipsis header-title" :title="$t('issueSeverity')">{{$t('issueSeverity')}}</div>
                  <div class="arrow" :class="arrowDirection.issueSeverity === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th v-if="manageComplianceColumns.indexOf('Issue Type')>-1">
                <div class="tableHeader  cursor-pointer" :class="manageComplianceColumns.indexOf('Issue Type')==0?'pl-12':''" @click="arrowDirection.issueType = -(arrowDirection.issueType), sortBy('issueType', arrowDirection.issueType)">
                  <div class="ellipsis header-title" :title="$t('issueType')">{{$t('issueType')}}</div>
                  <div class="arrow" :class="arrowDirection.issueType === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th v-if="manageComplianceColumns.indexOf('Resolve Within')>-1">
                <div class="tableHeader  cursor-pointer" :class="manageComplianceColumns.indexOf('Resolve Within')==0?'pl-12':''" @click="arrowDirection.resolve = -(arrowDirection.resolve), sortNumbers('resolve', arrowDirection.resolve)">
                  <div class="ellipsis header-title" :title="$t('resolveWithin')">{{$t('resolveWithin')}}</div>
                  <div class="arrow" :class="arrowDirection.resolve === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th v-if="manageComplianceColumns.indexOf('Certificate Number')>-1">
                <div class="tableHeader  cursor-pointer" :class="manageComplianceColumns.indexOf('Certificate Number')==0?'pl-12':''" @click="arrowDirection.certificateNumber = -(arrowDirection.certificateNumber), sortBy('certificateNumber', arrowDirection.certificateNumber)">
                  <div class="ellipsis header-title" :title="$t('certificateNumber')">{{$t('certificateNumber')}}</div>
                  <div class="arrow" :class="arrowDirection.certificateNumber === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th v-if="manageComplianceColumns.indexOf('Managed By')>-1">
                <div class="tableHeader  cursor-pointer" :class="manageComplianceColumns.indexOf('Managed By')==0?'pl-12':''" @click="arrowDirection.managedBy = -(arrowDirection.managedBy), sortBy('managedBy', arrowDirection.managedBy)">
                  <div class="ellipsis header-title" :title="$t('managedBy')">{{$t('managedBy')}}</div>
                  <div class="arrow" :class="arrowDirection.managedBy === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th v-if="manageComplianceColumns.indexOf('Certificate URL')>-1" >
                <div class="tableHeader  cursor-pointer" :class="manageComplianceColumns.indexOf('Certificate URL')==0?'pl-12':''" @click="arrowDirection.certificateURL = -(arrowDirection.certificateURL), sortBy('certificateURL', arrowDirection.certificateURL)">
                  <div class="ellipsis header-title" :title="$t('certificateURL')">{{$t('certificateURL')}}</div>
                  <div class="arrow" :class="arrowDirection.certificateURL === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th v-if="manageComplianceColumns.indexOf('Product ID')>-1">
                <div class="tableHeader  cursor-pointer"  :class="manageComplianceColumns.indexOf('Product ID')==0?'pl-12':''" @click="arrowDirection.registration_id = -(arrowDirection.registration_id), sortNumbers('registration_id', arrowDirection.registration_id)">
                  <div class="ellipsis header-title" :title="$t('productID')">{{$t('productID')}}</div>
                  <div class="arrow" :class="arrowDirection.registration_id === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th v-if="manageComplianceColumns.indexOf('Issue Status')>-1">
                <div class="tableHeader  cursor-pointer"  :class="manageComplianceColumns.indexOf('Issue Status')==0?'pl-12':''" @click="arrowDirection.issueStatus = -(arrowDirection.issueStatus), sortBy('issueStatus', arrowDirection.issueStatus)">
                  <div class="ellipsis header-title" :title="$t('issueStatus')">{{$t('issueStatus')}}</div>
                  <div class="arrow" :class="arrowDirection.issueStatus === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th></th>
              <th v-if="((roleId === 1|| roleId === roleInfo['Super Admin']) && (activeHeaderClass === 'Action Required' || activeHeaderClass === 'Ação Requerida'))"></th>

            </tr>

          <tbody ref="tbodyBox" v-if="renderFilterData.length">
            <tr class="viewRegistration"
            :class="index%2===0?'table_data_part1':'table_data_part2'"
            v-for="(data, index) in renderFilterData" :key="index" @click="viewManageComplianceDetails(data, $event)">

              <td v-if="manageComplianceColumns.indexOf('Issue Severity')>-1" class="ellipsis regulation-data" :class="manageComplianceColumns.indexOf('Issue Severity')==0?'first-column':'pl-8'">
                <img src="/static/images/icons/high_icon.svg" v-if="data.issueSeverity==='High'||data.issueSeverity==='Alta'" class="issue-type"/>
                <img src="/static/images/icons/medium_icon.svg"  v-if="data.issueSeverity==='Moderate'||data.issueSeverity==='Moderada'" class="issue-type"/>
                <img src="/static/images/icons/low_icon.svg" v-if="data.issueSeverity==='Low'||data.issueSeverity==='Baixa'"  class="issue-type"/>
                <span :title="data.issueSeverity">{{ data.issueSeverity }}</span>
              </td>
              <td v-if="manageComplianceColumns.indexOf('Issue Type')>-1" class="ellipsis regulation-data" :class="manageComplianceColumns.indexOf('Issue Type')==0?'first-column':'pl-8'"><span :title="data.issueType">{{ data.issueType }}</span></td>
              <td v-if="manageComplianceColumns.indexOf('Resolve Within')>-1" class="ellipsis regulation-data" :class="manageComplianceColumns.indexOf('Resolve Within')==0?'first-column':'pl-8'"><span :title="data.resolve">{{ data.resolve }}</span></td>
              <td v-if="manageComplianceColumns.indexOf('Certificate Number')>-1" class="ellipsis regulation-data" :class="manageComplianceColumns.indexOf('Certificate Number')==0?'first-column':'pl-8'"><span :title="data.certificateNumber">{{ data.certificateNumber }}</span></td>
              <td v-if="manageComplianceColumns.indexOf('Managed By')>-1" class="ellipsis regulation-data" :class="manageComplianceColumns.indexOf('Managed By')==0?'first-column':'pl-8'"><span :title="data.managedBy">{{ data.managedBy }}</span></td>
              <td v-if="manageComplianceColumns.indexOf('Certificate URL')>-1" class="ellipsis regulation-data" :class="manageComplianceColumns.indexOf('Certificate URL')==0?'first-column':'pl-8'"><span :title="data.certificateURL"><a style="color:#333333" href="data.certificateURL" target="_blank">{{ data.certificateURL }}</a></span></td>
              <td v-if="manageComplianceColumns.indexOf('Product ID')>-1" class="ellipsis regulation-data" :class="manageComplianceColumns.indexOf('Product ID')==0?'first-column':'pl-8'"><span :title="data.registration_id">{{data.registration_id}}</span></td>
              <td v-if="manageComplianceColumns.indexOf('Issue Status')>-1" class="ellipsis regulation-data" :class="manageComplianceColumns.indexOf('Issue Status')==0?'first-column':'pl-8'"><span :title="data.issueStatus">{{ data.issueStatus }}</span></td>

              <td  class="regulation-data">
                <div class="d-flex align-center justify-content-start" v-if="data.issueType === 'Pending Registration'|| data.issueType === 'Registro pendente'">
                  <button v-if="roleId===1 || roleId ===roleInfo['Super Admin']" class="removeButtonStyles" :disabled="data.issueStatus !== 'Action Required'&& data.issueStatus !== 'Ação Requerida'" :style="[(data.issueStatus !== 'Action Required'&&data.issueStatus !== 'Ação Requerida') ? {'opacity':'0.5','cursor':'not-allowed'} : '']" @click="redirectToEditRecord($event, data.registration_id)">
                  <img class="renew-certificate-icon" src="/static/images/icons/Resend.svg" alt="renew-certificate"/>
                  <span class="renewCertificate">{{$t('completeRegistration')}}</span>
                  </button>
                  <span class="info-img"></span>
                </div>
                <div v-else>
                <div class="d-flex align-center justify-content-start" v-if="data.issueStatus !== 'Ignored'&&data.issueStatus !== 'Ignorado'">
                  <button v-if="roleId===1 || roleId===roleInfo['Super Admin']" class="removeButtonStyles" :disabled="data.issueStatus !== 'Action Required'&& data.issueStatus !== 'Ação Requerida'" :style="[(data.issueStatus !== 'Action Required'&& data.issueStatus !== 'Ação Requerida') ? {'opacity':'0.5','cursor':'not-allowed'} : '']" @click="redirectToService($event, data.registration_id)">
                  <img class="renew-certificate-icon" src="/static/images/icons/Resend.svg" alt="renew-certificate"/>
                  <span class="renewCertificate">{{$t('renewCertificate')}}</span>
                  </button>
                  <span class="info-img"></span>
                </div>
                <div class="d-flex align-center justify-content-start" v-else>
                  <span>{{$t('ignored')}}</span>
                  <span class="info-img"></span>
                </div>
                </div>
              </td>
                <td v-if="((roleId === 1|| roleId === roleInfo['Super Admin']) && (activeHeaderClass === 'Action Required' || activeHeaderClass === 'Ação Requerida'))" >
                  <div class="dropdown dropdown-export custom-three-dots three-dots p-0 ">
                    <div data-toggle="dropdown" class="d-flex justify-content-end" @click="dropDownMenuDisable = true;">
                      <span class="dropdown-toggle cursor-pointer" data-toggle="tooltip" data-placement="right">
                        <img class="info-img" src="/static/images/icons/headlines_3_vertical_dots_menu.svg" />
                      </span>
                    </div>
                    <ul class="dropdown-menu tooltip-pointer dropdown-menu-ul" @click="stopPropagateMethod">
                      <li class="p-0 pl-0" @click="reviewCertificate($event,data.registration_id,true)">
                        <div>
                          <span class="MRL-4 edit-text">{{ $t('reviewCertificate') }}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                  </td>

             </tr>
          </tbody>
        </table>
         <div v-if="renderFilterData.length === 0">
              <p class="no-records-found">{{$t('noRecordsFound')}}</p>
            </div>
      </div>

    </div>

    <loader :loadingStatus="loaderStatus"></loader>
    <manage-compliance-popup :roleId="roleId" :details="complianceDetails" :roleInfo="roleInfo"></manage-compliance-popup>
    <subscription-popup from="manageCompliance"></subscription-popup>

    </div>

</div>
</template>
<script>
import $ from 'jquery';
import cloneDeep from 'clone-deep';
import * as moment from 'moment';
import EventBus from '../../utils/event-bus';
import SearchBox from '../UIComponents/ULSearchBox.vue';
// import ManageSharedLeftFilter from './ManageSharedLeftFilter.vue';
import { getManageComplianceData, updateStatus, getProductsAvailable } from '../../apis/registrations';
import Loader from '../UIComponents/Loader.vue';
import ManageCompliancePopup from '../UIComponents/ManageCompliancePopup.vue';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';
import { downloadCsvFile } from '../../utils/csv-download';
import SubscriptionPopup from './SubscriptionPopup.vue';

export default {
  mixins: [permissionsList],
  components: {
    SearchBox,
    // ManageSharedLeftFilter,
    Loader,
    ManageCompliancePopup,
    SubscriptionPopup,
  },
  props: {
    roleInfo: Object
  },
  data() {
    return {
      complianceDetails: {},
      searchValue: '',
      isPreviouslySearched: false,
      filteredManageComplianceData: [],
      renderFilterData: [],
      checkedValue: false,
      loaderStatus: true,
      headerTabOptions: ['In Progress', 'Action Required', 'Just Resolved', 'Ignored'],
      activeHeaderClass: '',
      sortKey: 'Product name',
      manageComplianceGridInfo: [],
      arrowDirection: {
        issueSeverity: 1,
        issueType: 1,
        issueStatus: 1,
        resolve: 1,
        managedBy: 1,
        certificateNumber: 1,
        certificateURL: 1,
        registration_id: 1,
      },
      manageComplianceColumns: ['Issue Severity', 'Issue Type', 'Resolve Within', 'Certificate Number', 'Managed By'],
      columnOptions: [],
      permissions: [],
      enableTable: false,
      roleId: '',
      searchCount: 0,
      isFilterApplied: true,
      dropDownMenuDisable: false,
    };
  },
  methods: {

    downloadRecords(event, data) {
      event.stopPropagation();
      let records = [];
      records = data.map((row) => ({
        'Issue Severity': row.issueSeverity,
        'Issue Type': row.issueType,
        'Resolve Within': row.resolve,
        'Certificate Number': row.certificateNumber,
        'Certification URL': row.certificateURL,
        'Product ID': row.registration_id,
        'Issue Status': row.issueStatus,
        'Managed by': row.managedBy,
      }));
      downloadCsvFile(records, 'ManageCompliance.csv');
    },
    convertToStrings(name) {
      switch (name) {
        case 'In Progress':
          name = 'in_progress';
          break;
        case 'Action Required':
          name = 'action_required';
          break;
        case 'Just Resolved':
          name = 'just_resolved';
          break;
        case 'Ignored':
          name = 'ignored';
          break;
        default:
          name = '';
          break;
      }
      return name;
    },
    translate(name) {
      if (this.$i18n.locale === 'Portuguese') {
        const res = this.convertToStrings(name);
        const data = {
          in_progress: 'Em Progresso',
          action_required: 'Ação Requerida',
          just_resolved: 'Resolvido Recentemente',
          ignored: 'Ignorado',
        };
        return data[res];
      }
      return name;
    },
    viewManageComplianceDetails(data, event) {
      this.complianceDetails = cloneDeep(data);
      this.complianceDetails.expirationDate = data.expirationDate ? moment.utc(data.expirationDate).format('DD/MM/YYYY') : '';
      this.complianceDetails.createdOn = moment.utc(data.createdOn).format('DD/MM/YYYY');

      if (event) {
        if (!$(event.target).closest('#export-dots').length) {
          if (!this.dropDownMenuDisable) {
            $('#manageComplianceDetails').modal({
              backdrop: 'static',
              keyboard: false,
            });
          } else {
            this.dropDownMenuDisable = false;
          }
        }
      } else {
        $('#manageComplianceDetails').modal({
          backdrop: 'static',
          keyboard: false,
        });
      }
    },
    handleActiveTab(tab) {
      this.searchValue = '';
      this.activeHeaderClass = tab;
      tab = this.translate(tab);
      this.filteredManageComplianceData = this.manageComplianceGridInfo.filter((each) => each.issueStatus === tab);
      this.renderFilterData = this.filteredManageComplianceData;
      this.searchCount = this.renderFilterData.length;
    },
    async redirectToService(event, id) {
      event.stopPropagation();
      const type = true;
      const response = await getProductsAvailable();
      const productsAvailable = response.data.productsLeft;
      if (productsAvailable) {
        await updateStatus(JSON.parse(localStorage.getItem('userData')).account_id, id);
        this.$router.push({ path: `/layout/registration/flow/add-record/${id}`, query: { type } });
      } else {
        $('#subscriptionPopup').modal({
          backdrop: 'static',
          keyboard: false,
        });
      }
    },
    stopPropagateMethod(event) {
      event.stopPropagation();
      event.preventDefault();
    },
    reviewCertificate(event, id, isReview) {
      this.$router.push({ path: `/layout/registration/flow/add-record/${id}`, query: { isReview } });
    },
    redirectToEditRecord(event, id) {
      event.stopPropagation();
      this.$router.push(`/layout/registration/flow/add-record/${id}`);
    },
    sortBy(type, direction) {
      if (direction === 1) this.renderFilterData.sort((a, b) => (a[type] > b[type] ? -1 : 1));
      else {
        this.renderFilterData.sort((a, b) => {
          if (a[type] === null) {
            a[type] = '';
          } else if (b[type] === null) {
            b[type] = '';
          }
          const firstElement = a[type].toUpperCase(); // ignore upper and lowercase
          const secondElement = b[type].toUpperCase(); // ignore upper and lowercase

          if (firstElement < secondElement) {
            return -1;
          }
          if (firstElement > secondElement) {
            return 1;
          }
          return 0;
        });
      }
    },
    sortNumbers(type, direction) {
      if (direction === 1) this.renderFilterData.sort((a, b) => b[type] - a[type]);
      else this.renderFilterData.sort((a, b) => a[type] - b[type]);
    },
    async getManageCompliance() {
      this.loaderStatus = true;
      const response = await getManageComplianceData();
      this.manageComplianceGridInfo = response;
      this.filteredManageComplianceData = this.manageComplianceGridInfo;
      this.loaderStatus = false;
    },
    filterManageComplianceList() {
      if (this.searchValue) {
        this.filterManageCompliance();
        this.isPreviouslySearched = true;
      } else if (this.isPreviouslySearched) {
        this.filterManageCompliance();
        this.isPreviouslySearched = false;
      }
    },
    async filterManageCompliance() {
      const searchStr = this.searchValue.trim();
      this.renderFilterData = [];
      if (!searchStr.length) {
        this.renderFilterData = this.filteredManageComplianceData;
        this.searchCount = this.renderFilterData.length;
        return;
      }
      this.renderFilterData = this.filteredManageComplianceData.filter((each) => this.searchString(searchStr, each));
      this.searchCount = this.renderFilterData.length;
    },
    searchString(searchValue, manageComplianceData) {
      if (manageComplianceData.issueSeverity === null) {
        manageComplianceData.issueSeverity = '';
        if ((manageComplianceData.issueSeverity.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
          return true;
        }
      } else if ((manageComplianceData.issueSeverity.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if (manageComplianceData.issueType === null) {
        manageComplianceData.issueType = '';
        if ((manageComplianceData.issueType.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
          return true;
        }
      } else if ((manageComplianceData.issueType.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }

      if (typeof (manageComplianceData.resolve) === 'number') {
        const resolveNumber = manageComplianceData.resolve.toString();
        if ((resolveNumber).indexOf(searchValue) !== -1) {
          return true;
        }
      }
      if (typeof (manageComplianceData.registration_id) === 'number') {
        const productId = manageComplianceData.registration_id.toString();
        if ((productId).indexOf(searchValue) !== -1) {
          return true;
        }
      }
      if ((manageComplianceData.certificateNumber.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((manageComplianceData.managedBy.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((manageComplianceData.certificateURL.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((manageComplianceData.issueStatus.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      return false;
    },
    updateColumns(columns, isFilterApplied) {
      this.isFilterApplied = isFilterApplied;

      this.manageComplianceColumns = [...columns];
    },
    updateFilterMode(isFilterApplied) {
      this.isFilterApplied = isFilterApplied;
    },

  },
  mounted() {
    $('#manageComplianceDetails').on('shown.bs.modal', () => {
      $('html').css('overflow', 'hidden');
    }).on('hidden.bs.modal', () => {
      $('html').css('overflow', 'auto');
    });
  },
  async created() {
    this.roleId = JSON.parse(localStorage.getItem('userData')).role_id;
    this.permissions = [];
    const servicesList = ['REG_TRACKER'];
    const modulesList = ['REG_TRACKER_RECORDS'];
    this.permissions = await this.permissionsList(servicesList, modulesList);
    if (this.permissions.indexOf('MANAGE_COMPLIANCE') === -1) {
      this.$router.push('/layout/PermissionAccess');
    } else {
      this.enableTable = true;
      this.columnOptions = this.manageComplianceColumns;
      await this.getManageCompliance();
      this.handleActiveTab('Action Required');
    }
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
  },
};
</script>
<style scoped>
.edit-text{
  color: #4D4D4D;
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 400;
}
.custom-three-dots {
  padding-right: 10px;
  padding-top: 5px;
}

.tooltip-pointer:before {
  position: absolute;
  top: -11px;
  height: 0;
  width: 0;
  /* left: 84%; */
  right: 4%;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 12px solid #ffffff;
  content: '';
}
.dropdown-menu-ul {
  right: 7px !important;
  left: unset;
}
.dropdown-menu li {
  padding:0px
}
.dropdown-menu-ul::after {
  right: 1em !important;
}
.dropdown-menu {
  /* left: -15px; */
  min-width: 166px;
  height: 39px;
  filter: drop-shadow(0px 0px 10px #b2b2b2);
  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.25);
  border-radius: 0px 0px 4px 4px;
  border: none;
  top: 42px !important;
  padding: 7px 17px 5px 16px;
  background: #ffffff;
}

.pl-8 {
   padding: 14px 0px 16px 8px !important;
}
.pl-12 {
    padding-left: 12px !important;
}
.renewCertificate{
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  color: #01518a;
}
.download_button,
.download_button:hover, .download_button:focus {
	background-color: #01518A;
	border: 1px solid #01518A;
	box-sizing: border-box;
	border-radius: 3px;
	color: #ffffff;
	font-weight: 600;
	font-size: 16px;
	font-family: 'Open Sans';
	line-height: 21px;
	padding: 6px 16px;
  height: 35px;
  min-width: 142px;

}
.pr-10 {
  padding-right: 10px;
}
.justify-content-between {
    justify-content: space-between !important;
}
/* .renew-certificate-icon{
  margin-right: 10px;
  margin-bottom: 5px;
} */
.removeButtonStyles {
  border: none;
  background: none;
  display: flex;
  align-items: center;
}
.arrow {
  margin-left: 2px;
}
.selected_row {
  background: #ECF5FC;
}
.checkbox {
    position: relative;
}

input[type="checkbox"] {
    opacity: 0;
    cursor: pointer;
    position: absolute;
    z-index: 1;
    width: 18px !important;
    height: 18px !important;
    left: 0;
    top: 0;
    margin: 0 !important;
}

.checkbox label:before {
    content: "";
    width: 18px !important;
    height: 18px !important;
    border: 2px solid #000000;
    display: inline-block;
    position: absolute;
    left: 0;
    top: -2px;
    border-radius: 3px;
}
.checkbox-file {
/*
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E; */
  padding: 14px 0px 0px 0px !important;

}

.checkbox.cust_checkbox input[type="checkbox"]:disabled+label:before {
    /* border: 1px solid #828282; */
    /* opacity: 0.5; */
}

.checkbox input[type="checkbox"]:checked+label:before {
    background-color: #01518A;
    background-image: url(/static/images/icons/checkbox.svg);
    background-size: 12px 15px;
    background-repeat: no-repeat;
    background-position-x: center;
    border: none;
}
/* .tbody.checkbox label{
  top: 7px !important;
} */
.checkbox label {
    cursor: auto;
    top: 5px;
    position: relative;
}

.cust_checkbox {
    /* margin: 0px; */
    margin: 0px 13px 0px 15px;
    display: inline-block;
}
.active_progress_bar {
  border-bottom:2px solid #00518A;
}
.test::after{
  position: absolute;
    content: '';
    height: 3px;
    width: 100%;
    border-bottom: 8px solid #4c9e45;
    background: none;
    left: 3px;
    bottom: 0;
}
.active-text {
  color:#000001;
}
.in-active-text {
  color:#3E3E3E;
}
.renewCertificate {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #01518A !important;
  padding-left: 4px;

}
.readiness_button,
.readiness_button:hover {
  background-color: #01518A;
  border-radius: 3px;
  /* border: 1px solid #000001; */
  min-height: 34px;
  min-width: 161px;
  color: #FFFFFF !important;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  padding: 6px 16px;
}

.consolidate_button,
.consolidate_button:hover {
  background-color: #ffffff;
  border-radius: 3px;
  border: 1px solid #000000;
  min-height: 34px;
  min-width: 161px;
  color: #000000 !important;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  padding: 6px 16px;
  margin-right: 24px;
}
.pl-28 {
  padding-left: 28px;
}
.pb-11 {
  padding-bottom: 8px;
}
.main-tabs {
  background: #F5F5F5;
  padding:11px 0px 0px 21px;
  display: flex;
  column-gap: 24px;
}
.regulation-header {
  padding:24px 0px 0px 24px
}
.btn-todo-list,
.btn-todo-list:hover {
  background: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #01518A;
  /* padding-bottom: 4px; */
}
.table_data_part1{
  background-color: #FAFAFA;
}
.table_data_part2{
  background-color: #F5F5F5;
}
.pb-22 {
  padding-bottom: 22px;
}
.pb-14 {
  padding-bottom: 14px;
}
.header-title{
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
}
.regulation-data {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  padding: 14px 0px 16px 8px !important;
}
.first-column {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  padding: 14px 0px 16px 12px !important;
  display: flex;
  align-items: center;
  column-gap: 18px;
}
.issue-type {
  height: 20px;
    width: 20px;
}

.regulation-message {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
}
.down-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #999999;
}

.up-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #999999;
}

.regulation-main{
    background-color: #ebebeb !important;
    /* height: calc(100vh - 50px) !important; */
     /* min-height: 786px; */
}
.filter-height{
min-height: 786px;
}
.table-height{
  height: calc(100vh - 50px) !important;
}
.regulation_check {
  font-weight: 400;
  font-size: 24px;
  line-height: 34px;
  color: #3E3E3E;
}
.tableHeader {
  display: flex;
  align-items: center;
  padding:14px 0px 12px 8px;
  column-gap: 7px
  /* justify-content: center; */
}
.regulationBackground {
  background-color: #ebebeb
}
#regulationDataList {
  /* margin-bottom:62px; */
}
#regulationDataList th .arrow {
  opacity: 1;
}
.pr-4 {
    padding-right:4px;
}

#regulationDataList thead,

#regulationDataList tbody,

#regulationDataList tr:not(#regulationDataList thead tr) {
 display: table;
 width: 100%;
table-layout: fixed;
}
.main-table {
  min-height: 800px;
}
@media (min-width: 2278px){
  .main-table {
    height: 100vh;
  }
}

/* .evidences::-webkit-scrollbar, .regulations::-webkit-scrollbar {
  width: 6px;
  height: 6px;

}

.evidences::-webkit-scrollbar-thumb, .regulations::-webkit-scrollbar-thumb {
  background: #CCCCCC;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;

}

.evidences, .regulations {
  overflow-x: scroll;
  margin-bottom: 25px;
}

.table {
  min-width: 110%;
  overflow-x: scroll;
  white-space: nowrap;
  margin-bottom:0px

} */
</style>
